<template>
    <div>
        <div class="el-input el-input--small">
            <gmap-autocomplete
                @place_changed="setPlace"
                :placeholder="$t('Search address')"
                class="el-input__inner"
            ></gmap-autocomplete>
        </div>
        <gmap-map class="mt-1 w-100" :center="modelValue" :zoom="12" style="height: 400px">
            <gmap-marker
                :position="modelValue"
                :draggable="true"
                @dragend="updatePlace"
            ></gmap-marker>
        </gmap-map>
        <div v-if="address" class="mt-1">
            {{ address.address_text }}
        </div>
    </div>
</template>

<script>
import geocode from '@/lib/util/geocode';

export default {
    name: 'addresssearch',
    props: {
        value: null,
        place: null,
        address: null,
        geocode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    mounted() {
        if (this.geocode && this.modelValue.lat && this.modelValue.lng) {
            this.getPlace(this.modelValue);
        }
    },
    computed: {
        userCoordinates() {
            return this.$store.getters.currentGeoLocationPosition;
        },
        modelValue: {
            get() {
                const { lat, lng } = this.value;
                const { lat: _lat, lng: _lng } = this.userCoordinates;

                return {
                    lat: parseFloat(lat || _lat),
                    lng: parseFloat(lng || _lng),
                };
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
    methods: {
        setPlace(place) {
            const lat =
                typeof place.geometry.location.lat == 'function'
                    ? place.geometry.location.lat()
                    : place.geometry.location.lat;
            const lng =
                typeof place.geometry.location.lng == 'function'
                    ? place.geometry.location.lng()
                    : place.geometry.location.lng;

            this.modelValue = { lat, lng };

            this.$emit('update:place', place);
            this.$emit('update:address', geocode.reverseGeoCode(place));
        },
        updatePlace({ latLng }) {
            this.getPlace({ lat: latLng.lat(), lng: latLng.lng() });
        },
        getPlace({ lat, lng }) {
            geocode.getPlace(lat, lng).then((place) => {
                this.setPlace(place);
            });
        },
    },
};
</script>
